import { computed } from "vue";
import { useServiceStore } from "../store/service";
import { useRouteUtils } from "./route";
import { gamecloudUrlFromRegion, regionToWi } from "./url";

export function useWiUtils() {
  const service = useServiceStore();

  const { locale, region } = useRouteUtils();

  const wiRegion = computed(() => (region.value ? regionToWi(region.value) : undefined));
  const homeUrl = computed(() => `/${locale.value}`);
  // The profile lives on the website; the webinterface's /{eur,int}/profile only redirects there.
  const profileUrl = computed(() => `/${locale.value}/profile`);
  const gamecloudUrl = computed(() => (wiRegion.value ? gamecloudUrlFromRegion(wiRegion.value) : undefined));
  const adminPanelUrl = computed(() => `/${wiRegion.value}/admin`);
  // Support lives on the website, which creates tickets in Intercom. The webinterface's own
  // ticket pages still write legacy tickets, so nothing here may point at them.
  const supportUrl = computed(() => `/${locale.value}/support`);
  // `?compose=1` opens the website's new-ticket form directly.
  const supportNewTicketUrl = computed(() => `/${locale.value}/support?compose=1`);
  const wikiUrl = computed(() => `/wiki/${locale.value}`);
  const discordUrl = "https://discord.gg/gportal";

  return {
    wiRegion,
    homeUrl,
    profileUrl,
    gamecloudUrl,
    adminPanelUrl,
    supportUrl,
    supportNewTicketUrl,
    wikiUrl,
    discordUrl,
  };
}
